import { Injectable } from '@angular/core';
import { MapApiService } from '../../../../widgets/map-widget/services/map-api.service';
import { LatLng } from 'leaflet';

@Injectable()
export class VesselMarkersHelperService {
  public set RegisterClickCallBack(cb: (id: string) => void) {
    this._mapApi.RegisterClickCallBack = cb;
  }
  public set RegisterHoverCallBack(cb: (id: string) => void) {
    this._mapApi.RegisterHoverCallBack = cb;
  }
  public set RegisterMapClickCB(cb: (latLng: LatLng) => void) {
    this._mapApi.RegisterMapClickCB = cb;
  }

  public set RemoveMarkerCallback(cb: (id: string) => void) {
    this._mapApi.SetRemoveMarkerCallback = cb;
  }

  public get RegisterCbs() {
    return this._mapApi;
  }
  constructor(private _mapApi: MapApiService) {}

  public clickMarker(id: string) {
    this._mapApi.activeMarker$.next(id);
  }
}
